import { useState } from 'react';
import { IconButton, Text } from 'theme-ui';
import ShoppingBagIcon from '~/assets/images/icons/shopping-bag.svg';

type Props = {
  color: string;
  handleOpenCart: () => void;
  itemCount: number | null;
  shouldSwapColor: boolean;
};

const CartButton = ({ color, handleOpenCart, shouldSwapColor, itemCount }: Props) => {
  const [touchStarted, setTouchStarted] = useState(false);
  return (
    <IconButton
      onClick={handleOpenCart}
      variant="bare"
      aria-label="Open Cart"
      onTouchStartCapture={() => setTouchStarted(true)}
      onTouchEndCapture={() =>
        setTimeout(() => {
          setTouchStarted(false);
        }, 250)
      }
      sx={{
        height: '100%',
        width: '4.8rem',
        display: 'flex',
        alignItems: 'center',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <div
        sx={{
          position: 'relative',
          svg: {
            height: '100%',
            width: ['1.6rem', null, '2.4rem'],
            path: {
              stroke: touchStarted ? 'UIGray1' : shouldSwapColor ? color : 'black',
              transition: 'stroke 0.3s ease-in-out',
            },
          },
        }}
      >
        <ShoppingBagIcon />
        <Text
          sx={{
            fontSize: ['0.8rem', '1.2rem'],
            lineHeight: 1.4,
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translate(-50%, 0)',
            fontWeight: 'bold',
            color: touchStarted ? 'UIGray1' : shouldSwapColor ? color : 'black',
            transition: 'color 0.3s ease-in-out',
          }}
        >
          {itemCount ? itemCount : null}
        </Text>
      </div>
    </IconButton>
  );
};

export default CartButton;
